export default __webpack_public_path__ + "static/media/inactive-timeline.0204cef6.png";